import { FC, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { ServiceScheduledEmails } from '../../services/service-scheduled-emails';
import { TabPage } from '../../components/shared/PageWithTabs/TabPage';
import { TabsType } from '../../components/shared/PageWithTabs/PageWithTabs';
import Card from '../../components/shared/Card/card';
import Field from '../../components/shared/Field/Field';
import BtButton from '../bt-button/bt-button';

type Props = { tabs: TabsType };

export const ScheduledEmailsTab: FC<Props> = ({ tabs }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!email) return;
    setLoading(true);
    try {
      const result = await ServiceScheduledEmails.sendTestSupplierInsuranceReminder(email);
      if (result.success) {
        NotificationManager.success(result.message || `Test email sent to ${email}`);
      } else {
        NotificationManager.error(result.message || 'Failed to send test email');
      }
    } catch (err: any) {
      NotificationManager.error(err?.response?.data?.message || err?.message || 'Failed to send test email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <TabPage tabs={tabs} title="Email Debug">
      <p style={{ color: 'var(--gray-600)', marginBottom: 24 }}>
        Debug tools for emails sent on a schedule by Azure Functions.
      </p>

      <Card title="Supplier Liability Insurance Reminder">
        <p style={{ color: 'var(--gray-700)', margin: '8px 0 16px', fontSize: 14 }}>
          Sends a sample reminder with dummy data — recipient "Erik Andersson",
          insurance type "Ansvarsförsäkring", expired 12 days ago.
        </p>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 240 }}>
            <Field
              type="email"
              placeholder="recipient@example.com"
              value={email}
              onChange={setEmail}
              disabled={loading}
            />
          </div>
          <BtButton onClick={handleSend} disabled={loading || !email}>
            Send Test
          </BtButton>
        </div>
      </Card>
    </TabPage>
  );
};
